import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { JsonPipe, NgClass } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FiieConsentExpandedTextComponent } from '../../components/expanded-text/fiie-consent-expanded-text/fiie-consent-expanded-text.component';
import { SpecialFactorsExpandedTextComponent } from '../../components/expanded-text/special-factors-expanded-text/special-factors-expanded-text.component';
import { NoAutocompleteDirective } from '../../directives/no-autocomplete/no-autocomplete.directive';
import { Help, HelpArea, HelpDictionary } from '../../services/help/help';
import { HelpModalConfig } from '../../services/help/help.service';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    MatIconButton,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    NgClass,
    MatFormField,
    MatLabel,
    NoAutocompleteDirective,
    MatInput,
    FormsModule,
    MatSuffix,
    MatCard,
    SpecialFactorsExpandedTextComponent,
    FiieConsentExpandedTextComponent,
    MatDialogActions,
    MatButton,
    JsonPipe,
  ],
})
export class HelpModalComponent implements OnInit {
  help: Help[];
  area: HelpArea;
  helpArea = HelpArea;
  canBrowse: boolean;
  searchText = '';
  filteredResults: Help[];
  selectedItem: HelpDictionary = {} as HelpDictionary;
  selectedDescriptorHtml: SafeHtml | null = null;
  nestedTerm: string;
  selected;
  iFrameLoaded = true;

  isFeatureFlagActive: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: HelpModalConfig,
    private dialogRef: MatDialogRef<HelpModalComponent>,
    private sanitizer: DomSanitizer
  ) {
    this.help = this.dialogData.help;
    this.canBrowse = this.dialogData.canBrowse;
    this.nestedTerm = this.dialogData.nestedTerm || null;
    this.area = this.dialogData.area || null;
    this.selected = {
      item: this.dialogData.item,
      section: this.dialogData.section,
    };
    this.isFeatureFlagActive = this.dialogData.isFeatureFlagActive;
  }

  ngOnInit(): void {
    this.filteredResults = this.help;
    this.searchText = this.selectedItem.label || '';
    this.getInitialItem();
  }

  filterDictionary() {
    if (this.searchText !== '') {
      this.filteredResults = this.filteredResults.map((help: Help) => ({
        title: help.title,
        dictionary: help.dictionary.filter((d) => d.label.toUpperCase().indexOf(this.searchText.toUpperCase()) > -1),
      }));
    } else {
      this.filteredResults = this.help;
    }
  }

  getInitialItem() {
    if (this.selected.item && this.selected.section) {
      const match = this.filteredResults
        .filter((r: Help) => r.title === this.selected.section)[0]
        .dictionary.filter((d: HelpDictionary) => d.label === this.selected.item)[0];
      this.setSelectedItem(match);
      this.searchText = match.label;
      this.filterDictionary();
    }
  }

  onIframeLoaded(): void {
    this.iFrameLoaded = true;
  }

  onSelectHelp(term: HelpDictionary) {
    this.setSelectedItem(term);
  }

  clearSearch() {
    this.searchText = '';
    this.filteredResults = this.help;
  }

  sanitizeUrl(link: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

  private setSelectedItem(term: HelpDictionary) {
    this.selectedItem = term;
    this.selectedDescriptorHtml = term.descriptor ? this.sanitizer.bypassSecurityTrustHtml(term.descriptor) : null;
  }

  onClose() {
    this.dialogRef.close();
  }
}
